module.exports = __webpack_public_path__ + "./audio/message_recieved.ca4db1bbac5a4fac41aa3b5409ab0f75.mp3";


//////////////////
// WEBPACK FOOTER
// ./assets/audio/message_recieved.mp3
// module id = ./assets/audio/message_recieved.mp3
// module chunks = 0